<template>
    <DialogTile title="Login">
        <Notification :type="n_type" :message="n_message" />
        <form @submit="startLogin">
            <input type="text" v-model="email" placeholder="Email" />
            <br>
            <input type="password" v-model="password" placeholder="Password" />
            <br>
            <input type="submit" value="login">
        </form>
        <router-link to="/register">Register</router-link>
    </DialogTile>
</template>

<script>
import { auth } from "../schmucklicloud";

export default {
    data() {
        return {
            email: "",
            password: "",

            n_type: "",
            n_message: ""
        }
    },
    methods: {
        startLogin(e) {
            e.preventDefault();

            auth.authorizeEmailPassword(this.email, this.password).then(function(response){
                if(response.isOK) {
                    window.localStorage.setItem("session_token", response.data.session_token);
                    this.n_type = "success";
                    setTimeout(function() {
                        this.$router.replace("/");
                    }.bind(this), 1000);
                } else {
                    this.n_type = "error";
                }
                this.n_message = response.message;
            }.bind(this));
        }
    }
}
</script>

<style scoped>
form {
    margin-bottom: 20px;
}
</style>